import { render, staticRenderFns } from "./MaterialTemplateEdit.vue?vue&type=template&id=446b8c8d&"
import script from "./MaterialTemplateEdit.vue?vue&type=script&lang=ts&"
export * from "./MaterialTemplateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports